import { Typography, styled } from '@mui/material';

import type { Theme } from '@mui/material';

export const StyledText = styled(Typography)(({ theme }: { theme?: Theme }) => ({
	position: 'relative',
	textAlign: 'center',
	zIndex: '1',
	display: 'inline-block',
	left: '50%',
	transform: 'translateX(-50%)',
	backgroundColor: theme?.palette.tsGoColor.grayLightest,
	paddingLeft: theme?.tsGoUnit.tsUnitHalf,
	paddingRight: theme?.tsGoUnit.tsUnitHalf,
	color: theme?.palette.tsGoColor.grayDark,
}));
